import { StatusKey } from '@/Enums/Advertisers/StatusKey.enum';
import { IAdvertiserFormData } from '@/Interfaces/Advertiser.interface';
import { GridSortModel } from '@mui/x-data-grid-pro';

export const DEFAULT_ADVERTISER: IAdvertiserFormData = {
  name: '',
  client: null,
  agency: null,
  domain: '',
  category: null,
  alternativeId: '',
};

export const ADVERTISERS_STATUS_LABELS = [
  { name: StatusKey.ALL, label: 'All' },
  { name: StatusKey.ACTIVE, label: 'Active' },
  { name: StatusKey.INACTIVE, label: 'Inactive' },
] as const;

export const STATUS_FILTER_MAP = {
  [StatusKey.ALL]: null,
  [StatusKey.ACTIVE]: true,
  [StatusKey.INACTIVE]: false,
};

export const BASE_TAB_ID = 'advertisers-filter-tab';

export const DEFAULT_SORTS: GridSortModel = [{ field: 'name', sort: 'asc' }];
